import { Avatar } from "@mui/material";

import locationIcon from "../../assets/locationicon.png";
import propertyIcon from "../../assets/bed.png";
import LoadingSM from "../dashboard/loading/LoadingSM";

import { components } from "react-select";

export const Option = (props) => {
  const { innerProps, data, children, state } = props;

  const icon = data.isProperty ? propertyIcon : locationIcon;

  const optionStyle = {
    color: state.isSelected ? "black" : "red",
    backgroundColor: state.isFocused ? "#f1f0ff" : null,
  };
  let labelText1 = data.label;
  let labelText2 = `${data.city} city in ${data.country ?? "Sri Lanka"}`;

  if (!data.isProperty) {
    const city = data?.label?.split(",")[0];
    const country = data?.label?.split(",")[1];
    labelText1 = city;
    labelText2 = country;
  }

  return (
    <div {...innerProps} className="location-search-item" style={optionStyle}>
      <Avatar src={icon} variant="square" sx={{ width: 32, height: 32 }} />
      <div className="location-search-info">
        <div className="location-search-item-title">{labelText1}</div>
        <div className="location-search-item-subtitle">{labelText2}</div>
      </div>
    </div>
  );
};

const CustomLoadingIndicator = () => {
  return (
    <div className="location-search-loading">
      <LoadingSM />
    </div>
  );
};

const CustomLoadingMessage = (props) => {
  return (
    <components.LoadingMessage {...props}>
      <span>Searching for properties and locations... </span>
    </components.LoadingMessage>
  );
};
export const customComponents = {
  DropdownIndicator: () => null,
  IndicatorSeparator: () => null,
  Option: (props) => (
    <Option
      {...props}
      state={props} // Pass the state prop to the custom Option component
    />
  ),
  LoadingIndicator: CustomLoadingIndicator,
  LoadingMessage: CustomLoadingMessage,
};

export const customStyles = {
  container: (provided, state) => ({
    ...provided,
    zIndex: "10",
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    display: "none",
  }),
  input: (provided) => ({
    ...provided,
    // "&::after": {
    //   display: "none", // Remove the ::after pseudo-element by setting its display to 'none'
    // },
  }),
  control: (provided, state) => ({
    ...provided,
    border: "1px solid #b8b8b8",
    boxShadow: "none",
    borderRadius: "var(--border-radius-md)",
    height: "50px",

    cursor: "text",
    fontSize: "1.1rem",

    "&:hover": {
      border: "1px solid #b8b8b8",
    },
  }),

  Option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "black" : "red",
    cursor: "pointer",
    fontSize: "1.1rem",
    "&:hover": {
      backgroundColor: "#f2f2f2",
    },
    // padding: "0px",

    // border: "1px solid #e3e3e3",
    borderBottom: "1px solid #cccccc", // Set your desired border style here
    padding: "8px 12px", // Adjust padding if needed
  }),

  group: (provided, state) => ({
    ...provided,
    padding: "0px",

    marginBottom: "16px", // Set your desired gap size here
  }),

  groupHeading: (provided, state) => ({
    ...provided,
    color: "rgb(33 , 37 , 41)", // Set your desired color here
    fontWeight: "bold", // Add any other styles you want
    fontSize: "16px", // Set your desired font size here

    padding: "0px",
    borderBottom: "1px solid #bebbbb",
    paddingBottom: "3px",
  }),

  // Set the menu height to auto
  menu: (provided, state) => ({
    ...provided,
    maxHeight: "unset",
    padding: "0px",
    boxShadow: "0 0 5px #8798ad",
  }),

  // Set the menuList height to auto
  menuList: (provided, state) => ({
    ...provided,
    maxHeight: "unset",
    overflow: "hidden",

    padding: "10px",
  }),

  singleValue: (provided, state) => ({
    ...provided,
    color: "black", // Set your desired color here
  }),
};
